import imageCompression from "browser-image-compression";
import { Field, Form, Formik } from "formik";
import { useIntl } from "react-intl";
import { ImageCompressConfig } from "../../../constants/ImageCompressConfig";
import { Input, Input3 } from "../../common/control/InputField";

export const AddBankForm = ({
  formikRef,
  fileInputRef,
  saveValues,
  imagePreview,
  setImagePreview,
}) => {
  const intl = useIntl();

  const handleFileChange = (event) => {
    const handleFile = (file, fileName) => {
      const newFile = new File([file], fileName, {
        type: file.type,
      });
      setImagePreview(URL.createObjectURL(newFile));
      formikRef.current?.setFieldValue("file", newFile);
    };
    const fileName = event.currentTarget.files[0].name;
    imageCompression(event.currentTarget.files[0], ImageCompressConfig)
      .then((res) => handleFile(res, fileName))
      .catch(() => handleFile(event.currentTarget.files[0], fileName));
  };

  return (
    <Formik
      initialValues={{
        bankname: "",
        accountname: "",
        accountnum: "",
        file: "",
      }}
      innerRef={formikRef}
      enableReinitialize={true}
      onSubmit={(values) => {
        let queryParams = {
          action: "addmasterbankaccount",
          ...values,
        };
        saveValues(queryParams);
      }}
    >
      {({ setFieldValue }) => (
        <Form>
          <div className="mb-2">
            <label className="mb-2 text-input-label" style={{ color: "white" }}>
              {intl.formatMessage({ id: "bankName" })}
            </label>

            <Field
              name="bankname"
              component={Input3}
              placeholder={intl.formatMessage({ id: "bankName" })}
              autoComplete="off"
              type="text"
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label" style={{ color: "white" }}>
              {intl.formatMessage({ id: "accountName" })}
            </label>

            <Field
              name="accountname"
              component={Input3}
              placeholder={intl.formatMessage({ id: "accountName" })}
              autoComplete="off"
              type="text"
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label" style={{ color: "white" }}>
              {intl.formatMessage({ id: "accountNum" })}
            </label>

            <Field
              name="accountnum"
              component={Input}
              placeholder={intl.formatMessage({ id: "accountNum" })}
              autoComplete="off"
              type="number"
            />
          </div>
          <div className="mb-2">
            <label className="mb-2 text-input-label">
              {intl.formatMessage({ id: "qrImage" })}
            </label>
            {imagePreview && imagePreview !== "" && (
              <div
                style={{ maxHeight: "200px" }}
                className="mb-2 position-relative"
              >
                <img
                  src={imagePreview}
                  style={{ maxHeight: "200px" }}
                  onError={() => setImagePreview(undefined)}
                />

                <i
                  className="position-absolute bi bi-x-circle-fill text-danger fs-5 cursor-pointer"
                  onClick={() => {
                    setImagePreview(undefined);
                    setFieldValue("file", undefined);
                    fileInputRef.current.value = "";
                  }}
                  style={{ top: "0px", left: "5px" }}
                />
              </div>
            )}

            <input
              type="file"
              className="form-control text-font2"
              placeholder={intl.formatMessage({ id: "image" })}
              autoComplete="off"
              accept="image/*"
              onChange={handleFileChange}
              ref={fileInputRef}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
